import gql from "graphql-tag";

const StoryCardFieldsFragment = gql`
  fragment StoryCardFields on Story {
    _id
    title
    slug
    introduction
    createdAt
    modifiedAt
    lastPublishedAt
    hasPodcast
    medias {
      url
      type
    }
    government {
      _id
      name
      logo
      city {
        _id
        country
      }
    }
    tags {
      _id
      name
      slug
    }
  }
`;

export default StoryCardFieldsFragment;
